import { render, staticRenderFns } from "./UpdatePoints.vue?vue&type=template&id=17fa59ce&scoped=true&"
import script from "./UpdatePoints.vue?vue&type=script&lang=js&"
export * from "./UpdatePoints.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePoints.vue?vue&type=style&index=0&id=17fa59ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fa59ce",
  null
  
)

export default component.exports